<template>
<div class="page page-contact">

  <!-- Hero -->
  <div class="hero contact-hero">

    <div class="hero-img">
      <parallax
        direction="down"
        breakpoint="(min-width: 50px)"
      >
        <picture>
          <source srcset="../assets/img/hero/contact-hero.jpg" media="(min-width: 576px)">
          <img srcset="../assets/img/hero/contact-hero-m.jpg" alt="">
        </picture>
      </parallax>
    </div>

    <div class="hero-content text-center">
        <h1 class="page-title">Contact Info</h1>
    </div>

  </div>

  <div class="container">
    <div class="contact-card">
      <div class="card">
        <div class="card-body">
          <h2 class="card-title">
            Saska Jansson
          </h2>
          <div class="contact-info">
            <div>
              <span class="field-label">Phone:</span>
              <a href="tel:12068185780">(206) 818-5780</a>
            </div>
            <div>
              <span class="field-label">Email:</span>
              <a href="mailto:saska@beach-built.com">saska@beach-built.com</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import Parallax from '@/components/Parallax'

export default {
  components: {
    Parallax
  },

  created () {
    this.$emit('ready')
  }
}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/imports';

.contact-hero {
  margin-bottom: 20px;
  @include media-breakpoint-up(md) {
    margin-bottom: 40px;
  }
}

.contact-card {
  max-width: 500px;
  margin: 0 auto;

  @include media-breakpoint-up(md) {
    .card-body {
      padding: rem(48);
    }
  }
}
</style>
